import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { ApplicantHistoryItem } from '../_models/applicant-history-item';

import { environment } from '../../environments/environment';

@Injectable()
export class ApplicantService {
  constructor(private http: Http) { }

    getApplicantHistory(applicantkey: string): Promise<ApplicantHistoryItem[]> {
        return this.http.get(environment.apiUrl + 'applicants/' + applicantkey)
        .toPromise()
        .then((response: Response) => response.json())
        .catch(x => console.log(x));
    }

}




// WEBPACK FOOTER //
// ./src/app/_services/applicant.service.ts